import React from 'react';

export default function PageFooter() {
  return (
    <div id="footer">
      <ul className="copyright">
        <li>&copy;2020 <a href="#">Sambit's Portfolio</a></li>
        <li>
           All Rights Reserved 
        </li>
      </ul>
    </div>

    
  );
}
